module.exports = __webpack_public_path__ + "static/img/7.2533784.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/4/zh/7.png
// module id = hRDK
// module chunks = 0